let openCredit = {
    byGateway: {},
    totalAvailable: 0,
};

function resetPledgePayOpenCredit() {
    openCredit = {
        byGateway: {},
        totalAvailable: 0,
    };
}

function clearPledgePayOpenCreditByGateway() {
    openCredit.byGateway = {};
}

function setPledgePayOpenCreditByGateway(byGateway) {
    openCredit.byGateway = byGateway && typeof byGateway === 'object' ? byGateway : {};
}

function setPledgePayOpenCreditTotalAvailable(amount) {
    const totalAvailable = Math.round(Math.max(0, parseFloat(amount) || 0) * 100) / 100;
    openCredit.totalAvailable = totalAvailable;
    return totalAvailable;
}

function setPledgePayOpenCredit(data) {
    if (!data || typeof data !== 'object') {
        return;
    }
    if (data.byGateway !== undefined) {
        setPledgePayOpenCreditByGateway(data.byGateway);
    }
    if (data.totalAvailable !== undefined && data.totalAvailable !== null) {
        setPledgePayOpenCreditTotalAvailable(data.totalAvailable);
    }
}

function getPledgePayOpenCreditByGateway() {
    return openCredit.byGateway;
}

function getPledgePayOpenBalanceAvailable() {
    const totalAvailable = openCredit.totalAvailable;
    return typeof totalAvailable === 'number' && Number.isFinite(totalAvailable)
        ? Math.max(0, totalAvailable)
        : 0;
}

function getPledgePayOpenCreditPoolForGateway(gatewayId) {
    const gatewayKey = String(gatewayId ?? '');
    const byGateway = openCredit.byGateway;
    return parseFloat(byGateway[gatewayKey] ?? byGateway[Number(gatewayKey)] ?? 0) || 0;
}

function sumPledgePayOpenCreditPools() {
    let total = 0;
    Object.keys(openCredit.byGateway).forEach((gatewayKey) => {
        total += parseFloat(openCredit.byGateway[gatewayKey]) || 0;
    });
    return total;
}

export {
    resetPledgePayOpenCredit,
    clearPledgePayOpenCreditByGateway,
    setPledgePayOpenCreditByGateway,
    setPledgePayOpenCreditTotalAvailable,
    setPledgePayOpenCredit,
    getPledgePayOpenCreditByGateway,
    getPledgePayOpenBalanceAvailable,
    getPledgePayOpenCreditPoolForGateway,
    sumPledgePayOpenCreditPools,
};
